// A usable number, or null. Absence is rejected BEFORE Number(): Number(null)
// and Number('') are 0 and finite, which would turn a missing value into a
// confident zero (CLAUDE.md, "Absence silently manufactured into a value").
// The one copy of this guard (issue #445); briefVisuals, the earnings helpers,
// the AI-analysis scores and the signal strengths all read through it.
export const finiteOrNull = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const number = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(number) ? number : null;
};
